import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as BuilderTasksActions from './builder-task.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class BuilderTasksStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.BUILDER_TASKS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new BuilderTasksActions.BuilderTasksCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new BuilderTasksActions.BuilderTasksUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new BuilderTasksActions.BuilderTasksDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new BuilderTasksActions.BuilderTasksRefresh(data.id));
          break;
      }
    });
  }
}
